export const TelemedicineStatus = {
	pending: "pending",
	active: "active",
	inactive: "inactive"
};
